import { FanSpeed2Icon } from './FanSpeed2Icon';

/**
 * author: Michael Irigoyen
 * id AFC8D4DB-4196-41E6-8EBC-A6509F96EA71
 * name fan-speed-2
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fan-speed-2.svg
 * tags
 * - Home Automation 
 */
export const FanSpeedMediumIcon = FanSpeed2Icon;
export default FanSpeedMediumIcon